/**
 * Agents Page Tour Steps
 * Tour for agent management features
 * Based on recommendations from react-joyride.md
 */
import { Step } from "react-joyride";

export const agentsSteps: Step[] = [
  {
    target: "body",
    content:
      "Welcome to Agent Management! Here you can view, search, and manage all your agents in one place.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tour="search-bar"]',
    content:
      "Use the search bar and filters to narrow agents by name, email, stage, owner, or tags. Quickly find the agents you're looking for.",
    placement: "bottom",
  },
  {
    target: '[data-tour="filter-drawer"]',
    content:
      "Click here to open advanced filters. Filter by tags, date ranges, and other criteria to segment your agent list.",
    placement: "bottom",
  },
  {
    target: '[data-tour="create-agent"]',
    content:
      "Click Add Agent to onboard a new agent. Fill in their contact information, assign an owner, and set their initial stage.",
    placement: "bottom",
  },
  {
    target: '[data-tour="agent-table"]',
    content:
      "View all agents in this table. Each row shows the agent's name, contact details, owner, stage, and date added. Click the arrow icon to view detailed information.",
    placement: "top",
  },
  {
    target: '[data-tour="stage-selector"]',
    content:
      "Update an agent's pipeline stage directly from this dropdown. Track their progress from Interview Scheduled to Active Agent.",
    placement: "left",
  },
  {
    target: '[data-tour="csv-actions"]',
    content:
      "Export your agent list to CSV or bulk import agents using our CSV template. Perfect for migrating data or creating backups.",
    placement: "bottom",
  },
];
